import React, { Component } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { fetchLiquidacionesListaSellers } from '../../../../actions/sellersActions';
import {
    fetchOrdenesParaNuevaLiquidacion,
    fetchNovedadesParaNuevaLiquidacion
} from '../../../../actions/LiquidacionesActions';
import { getLiquidacionesListaSellers, postNuevaLiquidacionFinal } from '../../../../api/axios.js';
import LiquidacionNewOrdenes from './LiquidacionNewOrdenes';
import LiquidacionNewNovedades from './LiquidacionNewNovedades';
import GoBackArrow from '../../../General/GoBackArrow';
import Select from 'react-select';
import { Spinner } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { DropDownArrow, EstiloCombos } from "../../../../template/CustomStyle";
import { filtroMedioMes } from '../../../../utilities/fechasFiltro';

// Wrapper para usar hooks en class component
function LiquidacionNewWrapper(props) {
  const navigate = useNavigate();
  return <LiquidacionNew {...props} navigate={navigate} />;
}
const fechaFiltro = filtroMedioMes();

class LiquidacionNew extends Component {
    constructor(props) {
        super(props);
        this.idOrdenesSeleccionadas = React.createRef();
        this.idNovedadesSeleccionadas = React.createRef();
        this.state = {
            hideSpinner: true,
            hiddenFirstSearch: true,
            lista_sellers_liquidaciones: [],
            lista_liquidaciones_busqueda: [],
            comboLiquidacionSeller: { label: "", value: "" },
            comboLiquidacionEstado: { label: "", value: "" },
            fechaDesdeSesenta: "",
            creating: false,
            request: {
                fechaDesde: fechaFiltro.desde,
                fechaHasta: fechaFiltro.hasta,
                idSeller: "",
                idEstado: 2
            }
        }
    };

    componentDidMount() {

        this.setState({ hiddenFirstSearch: true });
        localStorage.setItem("CrearLiquidacionSeller", "");

        let fechasesenta = new Date();
        fechasesenta.setDate(fechasesenta.getDate() - 360);
        let fechafechasesentafinal = fechasesenta.toISOString().slice(0, 10);
        this.setState({ fechaDesdesesenta: fechafechasesentafinal });

        /*CARGA DE SELLERS*/
        const cargasellers = getLiquidacionesListaSellers().then(res => {
            let listaTipo = res.listaSellersLiquidaciones.map((tipo) => {
                return { label: tipo.razonSocial, value: tipo.codigo.toString() };
            })

            this.setState({ lista_sellers_liquidaciones: listaTipo });
        });
    }

    myChangeHandler = async (e) => {
        const { name, value } = e.target;
        this.setState({ request: { ...this.state.request, [name]: value } });
    }

    onSubmitBusqueda = (event) => {

        event.preventDefault();
        let request = { ...this.state.request }

        if (request.fechaDesde == "") {
            toast.warn("Debe seleccionar una fecha inicial");
            return;
        }

        if (request.fechaHasta == "") {
            toast.warn("Debe seleccionar una fecha final");
            return;
        }

        if (localStorage.getItem('CrearLiquidacionSeller') == "" || localStorage.getItem('CrearLiquidacionSeller') == undefined) {
            toast.warn("Debe seleccionar un Seller");
            return;
        }

        request.idSeller = parseInt(localStorage.getItem('CrearLiquidacionSeller'));
        this.setState({ hiddenFirstSearch: false });

        this.props.fetchOrdenesParaNuevaLiquidacion(request);

        request.idEstado = 3;
        this.props.fetchNovedadesParaNuevaLiquidacion(request);
    }

    crearLiquidacion = async (event) => {

        event.preventDefault();
        this.setState({ hideSpinner: false });
        let idOrdenes = this.idOrdenesSeleccionadas
            .current
            .state
            .ordenes
            .filter(x => x.checked === true)
            .map(x => x.idOrden)
            ;

        if (idOrdenes.length === 0) {
            toast.warn("Selecione alguna orden. No puede crear una liquidacion sin orden");
            return;
        }

        let idNovedades = this.idNovedadesSeleccionadas
            .current
            .state
            .novedades
            .filter(x => x.checked === true)
            .map(x => x.idNovedad)
            ;

        let data = {
            ordenesSeleccionadas: idOrdenes,
            novedadesSeleccionadas: idNovedades,
            Seller: parseInt(localStorage.getItem('CrearLiquidacionSeller')),
            idEstado: 3
        }

        let post = postNuevaLiquidacionFinal(data);

        post.then(res => {
            toast.success("La liquidacion fue creada con éxito.");
            this.goToLiquidaciones();
        }).catch(err => {
            (err.response.data.errores) ?
                err.response.data.errores.forEach(error => toast.warn(error)) :
                toast.error("No pudimos crear la liquidación");
            this.goToLiquidaciones();
        });
    }

    crearLiquidacionBorrador = async (event) => {

        event.preventDefault();
        this.setState({creating: true})
        let idOrdenes = this.idOrdenesSeleccionadas
            .current
            .state
            .ordenes
            .filter(x => x.checked === true)
            .map(x => x.idOrden)
            ;

        if (idOrdenes.length === 0) {
            toast.warn("Selecione alguna orden. No puede crear una liquidacion sin orden");
            return;
        }

        let idNovedades = this.idNovedadesSeleccionadas
            .current
            .state
            .novedades
            .filter(x => x.checked === true)
            .map(x => x.idNovedad)
            ;

        let data = {
            ordenesSeleccionadas: idOrdenes,
            novedadesSeleccionadas: idNovedades,
            Seller: parseInt(localStorage.getItem('CrearLiquidacionSeller')),
            idEstado: 2
        }

        let post = postNuevaLiquidacionFinal(data);

        post.then(res => {
            toast.success("El borrador de liquidacion fue creado con éxito.");
            this.setState({ creating: false })
            this.goToLiquidaciones();
        }).catch(err => {
            (err.response.data.errores) ?
                err.response.data.errores.forEach(error => toast.warn(error)) :
                toast.error("No pudimos crear el borrador de liquidación");
            this.goToLiquidaciones();
        });
    }

    selectSearchHandlerLiquidacionesEstado = (options) => {
        let valor = { label: options.label, value: options.value.toString() };
        this.setState({ comboLiquidacionEstado: valor });
        localStorage.setItem('ListLiquidacionesEstado', options.value);
    }

    selectSearchHandlerLiquidacionesSeller = (options) => {
        let valor = { label: options.label, value: options.value.toString() };
        this.setState({ comboLiquidacionSeller: valor });
        localStorage.setItem('CrearLiquidacionSeller', options.value);

        const cargasellers = getLiquidacionesListaSellers().then(res => {
            let listaTipo = res.listaSellersLiquidaciones.map((tipo) => {
                return { label: tipo.razonSocial, value: tipo.codigo.toString() };
            });
            this.setState({ lista_sellers_liquidaciones: listaTipo });
        });
    }

    selectSearchHandlerLiquidacionesEstado = (options) => {
        let valor = { label: options.label, value: options.value.toString() };
        this.setState({ comboLiquidacionEstado: valor });
        localStorage.setItem('GestionDeLiquidacionEstado', options.value);
    }

    mapSellers = () => {
        getLiquidacionesListaSellers().then(res => {
            let listaTipo = res.listaSellersLiquidaciones.map((tipo) => {
                return { label: tipo.razonSocial, value: tipo.codigo.toString() };
            })
            this.setState({
                lista_sellers_liquidaciones: listaTipo
            })
        })
    }

    goToLiquidaciones = () => {
        this.props.navigate("/Liquidaciones");
    }


    render() {

        const isLoading = this.state.hiddenFirstSearch ||
            this.props.isLoadingOrdenesLiquidacion ||
            this.props.isLoadingNovedadesLiquidacion
            ;
        let ordenes = !Array.isArray(this.props.ordenesLiquidacion) ? {} : this.props.ordenesLiquidacion;
        let novedades = !Array.isArray(this.props.novedadesLiquidacion) ? {} : this.props.novedadesLiquidacion;


        return (
            <div className="ibox-content">

                <form className="form-horizontal form-material p-10" onSubmit={this.onSubmitBusqueda}>
                    <div className="ibox-content">
                        <div className="card">
                            <div className="row card-body justify-content-evenly align-items-center">

                                <div className="card-title mb-3 col-12">
                                    <div className="row">
                                        <div className="col-12 col-sm-auto">
                                            <GoBackArrow/>
                                        </div>
                                        <div className="col-12 col-sm-auto">
                                            <h4>Crear Liquidación</h4>
                                        </div>
                                    </div>
                                </div>

                                <div className="row justify-content-evenly align-items-center">

                                    <div className="col-12 col-md-3">
                                        <p className="font-bold">Desde</p>
                                        <input
                                            type="date"
                                            name="fechaDesde"
                                            className="form-control"
                                            onChange={this.myChangeHandler}
                                            max={fechaFiltro.hasta}
                                            min={this.state.fechaDesdesesenta}
                                            value={this.state.request.fechaDesde}
                                        />
                                    </div>

                                    <div className="col-12 col-md-3">
                                        <p className="font-bold">Hasta</p>
                                        <input
                                            type="date"
                                            name="fechaHasta"
                                            className="form-control"
                                            onChange={this.myChangeHandler}
                                            max={fechaFiltro.hasta}
                                            min={this.state.fechaDesdesesenta}
                                            value={this.state.request.fechaHasta}
                                        />
                                    </div>

                                    <div className="col-12 col-md-3">
                                        <p className="font-bold">Seller</p>
                                        <Select
                                            id="CrearLiquidacionSeller"
                                            name="CrearLiquidacionSeller"
                                            value={this.state.comboLiquidacionSeller}
                                            options={this.state.lista_sellers_liquidaciones}
                                            onChange={this.selectSearchHandlerLiquidacionesSeller}
                                            onMenuOpen={this.mapSellers}
                                            styles={EstiloCombos}
                                            components={{ DropdownIndicator: () => DropDownArrow }}
                                        />
                                    </div>

                                </div>

                                <div className="col-12 col-sm-auto mt-3">
                                    <button type="submit" className="btn btn-sm background-rojo-megatone">
                                        Buscar
                                    </button>
                                </div>

                            </div>
                        </div>
                    </div>
                </form>

                <div hidden={!this.props.isLoadingOrdenesLiquidacion && !this.props.isLoadingNovedadesLiquidacion}>
                    <div className="d-flex justify-content-center">
                        <Spinner animation="border" variant="secondary" size="lg-centrado" role="status">
                            <span className="sr-only">Loading...</span>
                        </Spinner>
                    </div>
                </div>

                <div hidden={isLoading}>

                    <div className="p-10">
                        <LiquidacionNewOrdenes
                            ordenes={ordenes}
                            ref={this.idOrdenesSeleccionadas}
                        />
                    </div>

                    <div className="p-10">
                        <LiquidacionNewNovedades
                            novedades={novedades}
                            ref={this.idNovedadesSeleccionadas}
                        />
                    </div>

                </div>

                <div
                    className="row justify-content-center align-items-center"
                    hidden={isLoading || ordenes.length === 0}
                >
                    <div className="col-auto">
                        <form
                            className="form-horizontal form-material"
                            onSubmit={this.crearLiquidacionBorrador}
                        >
                            <button
                                hidden={this.state.creating}
                                type="submit"
                                className="btn btn-sm background-rojo-megatone"
                                disabled={this.props.isLoadingOrdenesLiquidacion && this.props.isLoadingNovedadesLiquidacion}
                            >
                                Crear Borrador
                            </button>
                        </form>
                    </div>
                    <div className="d-flex justify-content-center">
                        <Spinner hidden={!this.state.creating} animation="border" variant="secondary" size="lg-centrado" role="status">
                            <span className="sr-only">Loading...</span>
                        </Spinner>
                    </div>
                </div>

            </div>
        );
    }
}


const mapStateToProps = state => ({
    tipoUsuario: state.general.tipoUsuario,
    lista_sellers_liquidaciones: state.sellers.lista_sellers_liquidaciones,
    isLoadingOrdenesLiquidacion: state.liquidaciones.isLoadingOrdenesLiquidacion,
    isLoadingNovedadesLiquidacion: state.liquidaciones.isLoadingNovedadesLiquidacion,
    ordenesLiquidacion: state.liquidaciones.ordenesLiquidacion,
    novedadesLiquidacion: state.liquidaciones.novedadesLiquidacion
});

export default connect(mapStateToProps, {
    fetchLiquidacionesListaSellers,
    fetchOrdenesParaNuevaLiquidacion,
    fetchNovedadesParaNuevaLiquidacion
}) (LiquidacionNewWrapper);